import React from "react";
import { Message } from "@zendeskgarden/react-forms";
import { t } from "../../translations/translation.service";

export interface CvMissingFieldMessageProps {
  field: string;
  missingFields?: string[];
}

/**
 * Aviso no próprio campo que o autopreenchimento não conseguiu extrair do
 * currículo, para o usuário saber o que ainda precisa digitar.
 */
const CvMissingFieldMessage: React.FC<CvMissingFieldMessageProps> = ({ field, missingFields }) =>
  missingFields?.includes(field)
    ? <Message validation="error">{t("CvCampoNaoEncontrado")}</Message>
    : null;

export default CvMissingFieldMessage;
